// extracted by mini-css-extract-plugin
export var chatHtmlText = "_pz-2";
export var chatLink = "_pz-0";
export var chatText = "_pz-1";